import React, { useContext } from 'react';
import 'bulma/css/bulma.min.css';

import { EsafDto } from '../api/api.ts';
import { SampleSetsContext } from '../sampleSetsProvider.tsx';
import { BeamlineContext } from '../beamlineProvider.tsx';


const EsafAsJson: React.FC = () => {

  const sampleSetsContext = useContext(SampleSetsContext);
  const beamlineContext = useContext(BeamlineContext);

  function clickedDownload() {
    const thisEsaf = sampleSetsContext.esaf;
    const sortedSets = sampleSetsContext.sets.getSortedSets();
    // Build an array of all Sets, as objects.
    const setData = sortedSets.map((s) => {
      // Combine the DTO of the Sample, with all its ParameterValues as an object.
      const samples = s.getSortedSamples().map((sample) => {
        const dtos = sample.asDtos();
        return {
          ...dtos[0],
          parameter_values: dtos[1]
        };
      });
      return {
        id: s.slug,
        name: s.name,
        description: s.description,
        samples: samples,
        last_modified: s.dateLastModified
      };
    });
    const parameters = beamlineContext.scanTypes.parameterIdsInDisplayOrder.map((pId) => {
      const parameter = beamlineContext.scanTypes.parametersById.get(pId);
      if (parameter) {
        return parameter.asDto();
      } else {
        return null;
      }
    });
    const esafData = {
      esaf: sampleSetsContext.esaf,
      sets: setData,
      parameterDefinitions: parameters
    }

    const jsonString = JSON.stringify(esafData, null, 2);

    // Create a Blob from the JSON string with the correct MIME type
    const blob = new Blob([jsonString], { type: 'application/json' });

    // Create, append, and programmatically click a temporary URL for the Blob
    const href = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    link.download = `esaf_${thisEsaf?.slug}_data.json`;
    document.body.appendChild(link);
    link.click();

    // Clean up the link and object URL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  }

  return (
    <a className="dropdown-item" onClick={ clickedDownload }>Download Data As JSON</a>
  )
}
export default EsafAsJson
